<template>
  <div class="center-screen">
    <div class="container">
      <div class="auth-page register">
        <h1 v-if="!isMobile">{{ $store.getters['getClientMeta'].name }} Ortaklık Programı</h1>
        <p v-if="!isMobile">Bizler, karşılıklı başarımıza ve her bir affiliate müşterimizle gerçek bir ortaklık deneyimi kurmaya ve sürdürmeye odaklanırız.</p>
        <div class="form">
          <div class="row">
            <div class="col col-4" v-if="!isMobile">
              <img v-if="!_.isNull(slider)" :src="$store.state.main.cdn_url + slider.image" width="100%">
            </div>
            <div class="col col-8">
              <div class="content">
                <h3 class="line-title">Ortaklık Programı Kayıt</h3>
                <form  class="auth-content flex row-wrap" @submit.prevent="onSubmit">
                      <div class="col col-6">
                        <div class="inline-form">
                          <label>Adınız</label>
                          <input type="text" placeholder="Adınızı yazınız" v-model="form.name">
                        </div>
                      </div>
                      <div class="col col-6">
                        <div class="inline-form">
                          <label>Soyadınız</label>
                          <input type="text" placeholder="Soyadınızı yazınız" v-model="form.surname">
                        </div>
                      </div>
                      <div class="col col-6">
                        <div class="inline-form">
                          <label>Şifreniz</label>
                          <input type="password" placeholder="Şifrenizi yazınız" v-model="form.password">
                        </div>
                      </div>
                      <div class="col col-6">
                        <div class="inline-form">
                          <label>Şifreniz Tekrar</label>
                          <input type="password" placeholder="Şifrenizi tekrar yazınız" v-model="form.password_r">
                        </div>
                      </div>
                      <div class="col col-6">
                        <div class="inline-form">
                          <label>E-Mail</label>
                          <input type="email" placeholder="E-Mailinizi yazınız" v-model="form.email">
                        </div>
                      </div>
                      <div class="col col-6">
                        <div class="inline-form">
                          <label>Website</label>
                          <input type="text" placeholder="Website adresiniz" v-model="form.website">
                        </div>
                      </div>
                      <div class="col col-6">
                        <div class="inline-form">
                          <label>Skype</label>
                          <input type="text" placeholder="Skype adresinizi yazınız" v-model="form.skype">
                        </div>
                      </div>
                      <div class="col col-6">
                        <div class="inline-form">
                          <label>Telefon</label>
                          <input type="number" placeholder="Telefon numaranızı yazınız" v-model="form.phone">
                        </div>
                      </div>
                      <div class="col col-12">
                        <div class="inline-form">
                          <ButtonLoader style="width:100%" class="primary stretch" :loader="isLoading" :text="'Başvuruyu Gönder'" >
                            <template name="icon">
                              <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                            </template>
                          </ButtonLoader>
                        </div>
                      </div>
                      <div class="col justify-flex-end">
                        <p>Zaten kayıtlı bir affiliate ortağımız mısınız? <a :href="affiliate_url">Giriş yapın</a></p>
                      </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
      name: 'Affiliate',
      metaInfo () {
        return {
          title: 'Affiliate | ' + _.get(this.$store.getters['getClientMeta'], 'main.title', ''),
        }
      },
      data(){
        return{
          form:{
						name: null,
						surname: null,
						password: null,
						password_r: null,
						email: null,
						phone: null,
						country: 'TR',
						website:'https://',
						skype:null,
          },
          isLoading: false,
          slider: null,
          affiliate_url: null,
        }
      },
      created(){
        this.fetchData();
      },
      methods:{
        fetchData(){
          this.$store.dispatch('getBanner', ['affiliate', 'both', 'top'])
          .then(response =>{
            this.slider  	= response.data[0];
          });
          axios.get('/affiliate')
              .then((response)=>{
                  if(response.data.status){
                    this.affiliate_url = response.data.affiliate_url;
                  }else{
                  }
              })
              .catch((err)=>{
                  
              })
        },
        onSubmit(evt){
          this.isLoading = true;
          axios.post('/affiliate', { ...this.form })
                .then((response)=>{
                  this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })

                  this.form = {
                    name: null,
                    surname: null,
                    password: null,
                    password_r: null,
                    email: null,
                    phone: null,
                    country: 'TR',
                    website:'https://',
                    skype:null,
                  }
              })
              .catch((err)=>{
                  
              })
              .finally(()=>{
                this.isLoading = false;
              })
        },
      }
  }
</script>